import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useTeam'

import type { TeamModel } from '@models/types'

const TeamListItem = (props: { team: TeamModel }) => {
  const { team } = props
  const { id, title } = team

  const { editTeamUrl } = generateUrls(team)

  return (
    <DashboardModuleListItem
      href={editTeamUrl}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default TeamListItem
